import { Link } from "react-router-dom";

export default function NeonCard({
  to,
  href,
  children,
  className = "",
  topAccent = "cyan",
  sideAccent = "magenta",
  ...rest
}) {
  const topColor =
    topAccent === "magenta"
      ? "#FF00FF"
      : topAccent === "lime"
        ? "#9FFF00"
        : topAccent === "orange"
          ? "#FF9900"
          : "#00FFFF";
  const sideColor =
    sideAccent === "cyan"
      ? "#00FFFF"
      : sideAccent === "lime"
        ? "#9FFF00"
        : sideAccent === "orange"
          ? "#FF9900"
          : "#FF00FF";

  const baseClass =
    "group relative block bg-mgfc-card/70 backdrop-blur-md p-6 transition-all duration-200 ease-linear hover:-translate-y-1.5";
  const interactive = to || href;
  const cls = [
    baseClass,
    interactive ? "cursor-pointer hover:bg-mgfc-card/90" : "",
    className,
  ].join(" ");

  const content = (
    <>
      <span
        className="pointer-events-none absolute inset-x-0 top-0 h-[2px]"
        style={{ background: topColor }}
      />
      <span
        className="pointer-events-none absolute inset-y-0 left-0 w-px opacity-50"
        style={{ background: sideColor }}
      />
      <span
        className="pointer-events-none absolute inset-y-0 right-0 w-px opacity-50"
        style={{ background: sideColor }}
      />
      <span
        className="pointer-events-none absolute inset-x-0 bottom-0 h-px opacity-30"
        style={{ background: sideColor }}
      />
      <span
        className="pointer-events-none absolute -inset-px opacity-0 transition-opacity duration-200 group-hover:opacity-100"
        style={{
          boxShadow: `0 0 30px ${topColor}66, inset 0 0 0 1px ${topColor}66`,
        }}
      />
      <div className="relative">{children}</div>
    </>
  );

  if (to) {
    return (
      <Link to={to} className={cls} {...rest}>
        {content}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} {...rest}>
        {content}
      </a>
    );
  }
  return (
    <div className={cls} {...rest}>
      {content}
    </div>
  );
}
